var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"yx-color-text-primary"},[_vm._v(_vm._s(_vm.row['remark'] || '-'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }